import styled, { css } from 'styled-components/macro';
import { BG_GRADIENT_PRODUCT_CARD, colorCoreBackground1000, colorCoreWhite1000, defaultTransparent, } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
export const ProductCardWrapperStyled = styled.div `
  position: relative;
  min-height: 350px;
  top: 0;

  border-top-color: ${({ topHorizontalLineColor }) => topHorizontalLineColor || colorCoreWhite1000};
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  ${({ withBackground }) => withBackground &&
    css `
      border-top-width: 8px;
      border-top-style: solid;

      background: ${BG_GRADIENT_PRODUCT_CARD};

      transition: border-top-color 300ms;

      ${ADAPTIVE.maxWidth.mobile} {
        border-top-width: 4px;
        border-top-color: ${defaultTransparent};
      }
    `}

  ${ADAPTIVE.minWidth.desktop} {
    ${({ hasMargin }) => hasMargin && 'margin: 0 48px'};
    ${({ topOffset }) => topOffset && `top: -${topOffset}`};
  }
`;
export const ProductDetailsPageWrapperStyled = styled.div `
  background: ${colorCoreBackground1000};
  width: 100%;
  height: auto;
`;
